import { Embroidery, ShoesState } from 'src/types'

// 基本料金計算
export const calculatorOfShoesBaseCost = (state: ShoesState): number => {
  switch (state.baseModel.brand) {
    case 'atoms': {
      const upperMaterial = state.upperMaterial.price // アッパー素材
      return upperMaterial
    }
    default: {
      return 0
    }
  }
}

// オプション料金計算
export const calculatorOfShoesOptionCost = (state: ShoesState): number => {
  switch (state.baseModel.brand) {
    case 'atoms': {
      const openingPattern = state.openingPattern.price // 履き口パターン
      const vampStrapType = state.vampStrapType.price // 甲止めタイプ
      const toeGuard = state.toeGuard.value === 'none' ? 0 : state.toeGuardKind.price // P革加工
      // const lineTypePrice = state.lineType.price // ラインタイプ ... 基本料金に含んでいるためコメントアウト
      const total = openingPattern + vampStrapType + toeGuard // + lineTypePrice
      return total
    }
    default: {
      return 0
    }
  }
}

// 刺繍料金計算
export const calculatorOfShoesEmbroideryCost = (state: ShoesState): number => {
  switch (state.baseModel.brand) {
    case 'atoms': {
      // 裏革1段目と2段目の刺繍をフィルタリング(位置のフィルタリング)
      const unitPricer = (e?: Embroidery) => {
        if (e === undefined) {
          return 0
        }
        if (e.position.value === 'healDecoration') {
          // 踵かざり部(両足)... 2箇所分の刺繍料金がかかる
          const unitPrice = 1540
          const mount = 2

          return unitPrice * mount
        }
        // スパイク刺繍は単色刺繍のみ // 2025/06/04時点
        const price = 1540
        return price
      }
      const embroideriesOfFiltered = state.embroideries.filter((e) => e.content.trim()?.length > 0)
      const costsOfEmbroideries = embroideriesOfFiltered.map(unitPricer)
      const total = costsOfEmbroideries.reduce((a, c) => a + c, 0)
      return total
    }
    default: {
      return 0
    }
  }
}
